// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3knlk","requiredAsterisk":"Info_requiredAsterisk__2mLvE"};